import React from 'react';
import AutoStackedAreaChart from '../AutoStackedAreaChart';
import { formatDateStr, getRoundIntegerNum, getNumberOfDotUnit } from '@gp/utils/common';
import { getChartData, transferHistories } from '../../utils/dataTransfer';

import type { IBaseProps } from '@home/types/common';

export interface ICurrentHeadcountData {
  value?: string;
  line_chart?: Record<string, string>[];
}

interface ICurrentHeadcountProps extends IBaseProps {
  data?: ICurrentHeadcountData;
}

const dateCategoryLabelFormatter = (date: string, index: number, total: number): string => {
  const dateFormatted = formatDateStr(date, 'YYYY-MM');
  if (!dateFormatted) return '';
  if (index === 0 || index === total - 1) return dateFormatted;
  return dateFormatted?.substring(dateFormatted?.length - 2);
};

const valueFormatter = (params?: { value: string; }) => getNumberOfDotUnit(params?.value);

const CurrentHeadcount: React.FC<ICurrentHeadcountProps> = (props: any) => {
  const { data } = props;
  const { value, line_chart: lineCharts } = data || {};

  return (
    <div className="dbg-finance-card-flex">
      <div className="dbg-finance-card-left">
        <div className="dbg-finance-card-num">{getRoundIntegerNum(value)}</div>
      </div>
      <div style={{ width: '100%', height: '80px', textAlign: 'right' }}>
        <AutoStackedAreaChart
          data={getChartData(transferHistories(lineCharts))}
          categoryLabelFormatter={dateCategoryLabelFormatter}
          valueFormatter={valueFormatter}
        />
      </div>
    </div>
  );
};

export default CurrentHeadcount;
